import { useState, useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, apiError } from "../api";

export default function SettingsPage() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["settings"], queryFn: async () => (await api.get("/settings")).data });
  const [s, setS] = useState(null);
  useEffect(() => { if (data && !s) setS(data); }, [data, s]);
  if (!s) return <p className="veri">Yükleniyor…</p>;
  const set = (k, v) => setS({ ...s, [k]: v });
  const kaydet = async () => {
    try { await api.put("/settings", s); qc.invalidateQueries({ queryKey: ["settings"] }); toast.success("Ayarlar kaydedildi"); }
    catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div className="a-form">
      <h1 style={{ fontFamily: "var(--display)", fontSize: 26 }}>Ayarlar</h1>
      <div className="grid2">
        <div><label>Logo metni</label><input value={s.logo_text || ""} onChange={(e) => set("logo_text", e.target.value)} data-testid="ayar-logo" /></div>
        <div><label>Telefon</label><input value={s.phone || ""} onChange={(e) => set("phone", e.target.value)} /></div>
      </div>
      <div className="grid2">
        <div><label>WhatsApp (ülke kodlu, sadece rakam)</label><input value={s.whatsapp || ""} onChange={(e) => set("whatsapp", e.target.value)} /></div>
        <div><label>E-posta</label><input value={s.email || ""} onChange={(e) => set("email", e.target.value)} /></div>
      </div>
      <div><label>Ofis adresi</label><input value={s.address || ""} onChange={(e) => set("address", e.target.value)} /></div>
      <div><label>Harita gömme (iframe src)</label><input value={s.map_embed || ""} onChange={(e) => set("map_embed", e.target.value)} /></div>
      <div><label>Çalışma saatleri</label><input value={s.working_hours || ""} onChange={(e) => set("working_hours", e.target.value)} /></div>
      <div><label>KVKK metni</label><textarea rows={3} value={s.kvkk_text || ""} onChange={(e) => set("kvkk_text", e.target.value)} data-testid="ayar-kvkk" /></div>
      <label className="a-satir"><input type="checkbox" checked={!!s.maintenance} onChange={(e) => set("maintenance", e.target.checked)} /> Bakım modu</label>
      <button className="a-btn bal" onClick={kaydet} data-testid="ayar-kaydet">Kaydet</button>
    </div>
  );
}
